module.exports = __webpack_public_path__ + "img/Vectormet.4d3300b5.png";